import SentryInitializer from '@root/joinroot.com/src/utils/sentry-initializer';
import { useEffect } from '@root/vendor/react';

export default function SentryInitializationController() {
  useEffect(() => {
    SentryInitializer.init();
  }, []);

  return null;
}
